(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bundle-selector"] && !Shopify.designMode) return;
  try {
    class BundleSelector extends HTMLElement {
    static scrollStorageKey = 'bundle-selector-scroll-after-navigation';
    static whatsIncludedEventName = 'bundle-selector:whats-included-change';

    connectedCallback() {
      this.#scrollIntoViewAfterNavigation();
      this.#bindMobileNavigationScroll();
      this.#dispatchWhatsIncludedFromCurrentCard();

      const track = this.querySelector('[data-bundle-selector-track]');

      if (!track) {
        return;
      }

      this.#initMobileScrollbar(track);

      if (!window.matchMedia('(pointer: fine)').matches) {
        return;
      }

      const dragThreshold = 8;
      let isPointerDown = false;
      let isDragging = false;
      let startX = 0;
      let scrollLeft = 0;
      let suppressNextClick = false;

      const endDrag = () => {
        isPointerDown = false;
        isDragging = false;
        track.classList.remove('is-dragging');
      };

      const onPointerMove = (event) => {
        if (!isPointerDown) {
          return;
        }

        const walk = event.pageX - startX;

        if (!isDragging && Math.abs(walk) < dragThreshold) {
          return;
        }

        isDragging = true;
        suppressNextClick = true;
        track.classList.add('is-dragging');
        track.scrollLeft = scrollLeft - walk;
      };

      const onPointerUp = () => {
        if (!isPointerDown) {
          return;
        }

        endDrag();
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        document.removeEventListener('pointercancel', onPointerUp);
      };

      track.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) {
          return;
        }

        isPointerDown = true;
        isDragging = false;
        suppressNextClick = false;
        startX = event.pageX;
        scrollLeft = track.scrollLeft;

        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', onPointerUp);
        document.addEventListener('pointercancel', onPointerUp);
      });

      track.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });

      track.addEventListener(
        'click',
        (event) => {
          if (!suppressNextClick) {
            return;
          }

          suppressNextClick = false;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
    }

    #initMobileScrollbar(track) {
      const scrollbar = this.querySelector('[data-bundle-selector-mobile-scrollbar]');
      const thumb = this.querySelector('[data-bundle-selector-mobile-scrollbar-thumb]');

      if (!scrollbar || !thumb) {
        return;
      }

      let frame = null;

      const updateScrollbar = () => {
        frame = null;

        const maxScroll = track.scrollWidth - track.clientWidth;
        const scrollbarWidth = scrollbar.clientWidth;

        if (maxScroll <= 1 || scrollbarWidth <= 0) {
          scrollbar.classList.add('is-hidden');
          return;
        }

        scrollbar.classList.remove('is-hidden');

        const thumbWidth = Math.max((track.clientWidth / track.scrollWidth) * scrollbarWidth, 40);
        const thumbOffset = (track.scrollLeft / maxScroll) * (scrollbarWidth - thumbWidth);

        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${thumbOffset}px)`;
      };

      const requestUpdate = () => {
        if (frame) {
          return;
        }

        frame = window.requestAnimationFrame(updateScrollbar);
      };

      track.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      window.requestAnimationFrame(updateScrollbar);
    }

    #bindMobileNavigationScroll() {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        return;
      }

      for (const link of this.querySelectorAll('.bundle-selector__card-link')) {
        link.addEventListener('click', (event) => {
          if (event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
            return;
          }

          sessionStorage.setItem(
            BundleSelector.scrollStorageKey,
            JSON.stringify({
              timestamp: Date.now(),
            })
          );
        });
      }
    }

    #scrollIntoViewAfterNavigation() {
      if (!window.matchMedia('(max-width: 749px)').matches) {
        return;
      }

      const rawScrollIntent = sessionStorage.getItem(BundleSelector.scrollStorageKey);

      if (!rawScrollIntent) {
        return;
      }

      sessionStorage.removeItem(BundleSelector.scrollStorageKey);

      try {
        const scrollIntent = JSON.parse(rawScrollIntent);

        if (!scrollIntent?.timestamp || Date.now() - scrollIntent.timestamp > 10000) {
          return;
        }
      } catch (_error) {
        return;
      }

      window.requestAnimationFrame(() => {
        window.requestAnimationFrame(() => {
          const stickyOffset = this.#stickyHeaderOffset();
          const top = this.getBoundingClientRect().top + window.scrollY - stickyOffset;

          window.scrollTo({
            top: Math.max(top, 0),
            behavior: 'smooth',
          });
          this.#scrollCurrentCardIntoView();
        });
      });
    }

    #scrollCurrentCardIntoView() {
      const track = this.querySelector('[data-bundle-selector-track]');
      const currentCard = this.querySelector('.bundle-selector__card--current');

      if (!track || !currentCard) {
        return;
      }

      const trackRect = track.getBoundingClientRect();
      const cardRect = currentCard.getBoundingClientRect();
      const targetLeft = track.scrollLeft + cardRect.left - trackRect.left - (track.clientWidth - currentCard.clientWidth) / 2;

      track.scrollTo({
        left: Math.max(targetLeft, 0),
        behavior: 'smooth',
      });
    }

    #stickyHeaderOffset() {
      const header = document.querySelector('#header-component');
      const headerHeight = header ? header.getBoundingClientRect().height : 0;
      const headerGroupHeight = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-group-height')) || 0;

      return Math.max(headerHeight, headerGroupHeight) + 12;
    }

    #dispatchWhatsIncludedFromCard(card) {
      const whatsIncluded = card?.dataset.whatsIncluded?.trim() || '';

      document.dispatchEvent(
        new CustomEvent(BundleSelector.whatsIncludedEventName, {
          detail: { whatsIncluded },
          bubbles: true,
        })
      );
    }

    #dispatchWhatsIncludedFromCurrentCard() {
      const card = this.querySelector('.bundle-selector__card--current');
      this.#dispatchWhatsIncludedFromCard(card);
    }
  }

  if (!customElements.get('bundle-selector')) {
    customElements.define('bundle-selector', BundleSelector);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["price-was-now"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__wasNowBound) return;
    window.__wasNowBound = true;

    document.addEventListener('variant:update', (event) => {
      const detail = event.detail || {};
      const data = detail.data || {};
      let html = data.html;
      if (!html || data.newProduct) return;

      if (typeof html === 'string') {
        html = new DOMParser().parseFromString(html, 'text/html');
      }

      const productId = String(data.productId || '');
      const scope =
        (event.target instanceof Element &&
          event.target.closest('product-card, .product-card, .product-information, section')) ||
        document;

      scope.querySelectorAll('[data-was-now]').forEach((el) => {
        if (productId && el.dataset.productId !== productId) return;
        const next = html.querySelector(`[data-was-now="${el.dataset.wasNow}"]`);
        if (next) el.innerHTML = next.innerHTML;
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__mcBundleSwatches) return;
    window.__mcBundleSwatches = true;

    function getTitleEl(card) {
      return card ? card.querySelector('.product-swatches__selected') : null;
    }

    // Hover a swatch: preview that scent's name.
    document.addEventListener('pointerover', function (event) {
      if (!event.target.closest) return;
      var label = event.target.closest('.variant-option__button-label[data-swatch-title]');
      if (!label) return;
      var card = label.closest('product-card');
      var el = getTitleEl(card);
      if (el && label.dataset.swatchTitle) el.textContent = label.dataset.swatchTitle;
    });

    // Leave the swatch row: revert name + image to the selected scent so nothing drops.
    document.addEventListener('pointerout', function (event) {
      if (!event.target.closest) return;
      var fieldset = event.target.closest('.variant-option--swatches');
      if (!fieldset) return;
      if (event.relatedTarget && fieldset.contains(event.relatedTarget)) return;
      var card = fieldset.closest('product-card');
      if (!card) return;
      var checked = fieldset.querySelector('input:checked');
      var label = checked && checked.closest('.variant-option__button-label');
      var el = getTitleEl(card);
      if (el && label && label.dataset.swatchTitle) el.textContent = label.dataset.swatchTitle;
      var mediaId = checked && checked.dataset.optionMediaId;
      if (mediaId && typeof card.previewVariant === 'function') card.previewVariant(mediaId);
    });

    // Select a swatch: lock the scent name + point the Shop now button at that variant.
    document.addEventListener('change', function (event) {
      if (!event.target.closest) return;
      var input = event.target.closest('.variant-option--swatches input[type=radio]');
      if (!input) return;
      var label = input.closest('.variant-option__button-label');
      var card = input.closest('product-card');
      var el = getTitleEl(card);
      if (el && label && label.dataset.swatchTitle) el.textContent = label.dataset.swatchTitle;

      var cta = card && card.querySelector('.product-swatches__cta');
      var variantId = input.dataset.variantId;
      if (cta && variantId) {
        var base = cta.dataset.productUrl || (cta.getAttribute('href') || '').split('?')[0];
        cta.setAttribute('href', base + '?variant=' + variantId);
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["variant-bundle-selector"] && !Shopify.designMode) return;
  try {
    const variantUpdateEventName = 'variant:update';
  const whatsIncludedEventName = 'bundle-selector:whats-included-change';

  class VariantBundleSelector extends HTMLElement {
    connectedCallback() {
      this.#initMobileScrollbar();
      this.#initDragScroll();
      this.#hideThemeVariantPicker();
      this.#bindCardClicks();
      this.#syncCurrentCardFromPicker();

      this.#handleVariantUpdate = this.#handleVariantUpdate.bind(this);
      this.#sectionTarget()?.addEventListener(variantUpdateEventName, this.#handleVariantUpdate);
    }

    disconnectedCallback() {
      this.#sectionTarget()?.removeEventListener(variantUpdateEventName, this.#handleVariantUpdate);
    }

    #dispatchWhatsIncludedFromCard(card) {
      const whatsIncluded = card?.dataset.whatsIncluded?.trim() || '';

      document.dispatchEvent(
        new CustomEvent(whatsIncludedEventName, {
          detail: { whatsIncluded },
          bubbles: true,
        })
      );
    }

    #sectionTarget() {
      return this.closest('.shopify-section, dialog');
    }

    #shouldHideVariantPicker() {
      return this.dataset.hideVariantPicker === 'true';
    }

    #getThemeVariantPicker() {
      const productDetails = this.closest('product-details-component, [data-product-details], .product-details');

      if (productDetails) {
        const pickerInDetails = productDetails.querySelector('variant-picker');

        if (pickerInDetails) {
          return pickerInDetails;
        }
      }

      const section = this.#sectionTarget();
      const pickers = section?.querySelectorAll('variant-picker');

      if (!pickers?.length) {
        return null;
      }

      return pickers[0];
    }

    #hideThemeVariantPicker() {
      if (!this.#shouldHideVariantPicker()) {
        return;
      }

      const picker = this.#getThemeVariantPicker();

      if (picker) {
        picker.classList.add('is-visually-hidden');
        picker.setAttribute('inert', '');
        picker.setAttribute('aria-hidden', 'true');
      }
    }

    #bindCardClicks() {
      for (const button of this.querySelectorAll('[data-variant-bundle-card]')) {
        button.addEventListener('click', () => {
          const variantId = button.dataset.variantId;

          if (!variantId || button.disabled) {
            return;
          }

          this.#selectVariant(variantId);
        });
      }
    }

    #handleVariantUpdate(event) {
      const variantId = event.detail?.resource?.id;

      if (!variantId) {
        return;
      }

      this.#hideThemeVariantPicker();
      this.#setCurrentCard(variantId);
      this.#syncSkioVariantInput(variantId);
    }

    #selectVariant(variantId) {
      this.#setCurrentCard(variantId);

      const picker = this.#getThemeVariantPicker();
      const pickerInput = picker?.querySelector(`input[data-variant-id="${variantId}"]`);

      if (pickerInput instanceof HTMLInputElement) {
        pickerInput.checked = true;
        pickerInput.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }

      const selectOption = picker?.querySelector(`option[data-variant-id="${variantId}"]`);

      if (selectOption instanceof HTMLOptionElement && selectOption.parentElement instanceof HTMLSelectElement) {
        selectOption.parentElement.value = selectOption.value;
        selectOption.parentElement.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    #syncCurrentCardFromPicker() {
      const picker = this.#getThemeVariantPicker();
      const checkedInput = picker?.querySelector('input[data-variant-id]:checked');

      if (checkedInput instanceof HTMLInputElement && checkedInput.dataset.variantId) {
        this.#setCurrentCard(checkedInput.dataset.variantId);
        return;
      }

      const selectedOption = picker?.querySelector('option[data-variant-id]:checked');

      if (selectedOption instanceof HTMLOptionElement && selectedOption.dataset.variantId) {
        this.#setCurrentCard(selectedOption.dataset.variantId);
      }
    }

    #syncSkioVariantInput(variantId) {
      const formId = this.dataset.formId;

      if (!formId) {
        return;
      }

      const form = document.getElementById(formId) || document.querySelector(`form#${CSS.escape(formId)}`);
      const variantInput = form?.querySelector('[name="id"]');

      if (!(variantInput instanceof HTMLInputElement)) {
        return;
      }

      if (variantInput.value === String(variantId)) {
        return;
      }

      variantInput.value = String(variantId);
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }

    #setCurrentCard(variantId) {
      let currentVariantTitle = '';

      for (const card of this.querySelectorAll('.bundle-selector__card')) {
        const isCurrent = card.dataset.variantId === String(variantId);
        card.classList.toggle('bundle-selector__card--current', isCurrent);

        if (isCurrent) {
          currentVariantTitle = card.dataset.variantTitle || '';
        }

        const button = card.querySelector('[data-variant-bundle-card]');

        if (button instanceof HTMLButtonElement) {
          if (isCurrent) {
            button.setAttribute('aria-current', 'true');
          } else {
            button.removeAttribute('aria-current');
          }
        }
      }

      this.#updateVariantHeading(currentVariantTitle);
      this.#dispatchWhatsIncludedFromCard(
        this.querySelector(`.bundle-selector__card[data-variant-id="${variantId}"]`)
      );
    }

    #updateVariantHeading(variantTitle) {
      if (!variantTitle) {
        return;
      }

      const heading = this.closest('.product-details')?.querySelector('h4');

      if (heading) {
        heading.textContent = variantTitle;
      }
    }

    #initMobileScrollbar() {
      const track = this.querySelector('[data-variant-bundle-selector-track]');
      const scrollbar = this.querySelector('[data-variant-bundle-selector-mobile-scrollbar]');
      const thumb = this.querySelector('[data-variant-bundle-selector-mobile-scrollbar-thumb]');

      if (!track || !scrollbar || !thumb) {
        return;
      }

      let frame = null;

      const updateScrollbar = () => {
        frame = null;

        const maxScroll = track.scrollWidth - track.clientWidth;
        const scrollbarWidth = scrollbar.clientWidth;

        if (maxScroll <= 1 || scrollbarWidth <= 0) {
          scrollbar.classList.add('is-hidden');
          return;
        }

        scrollbar.classList.remove('is-hidden');

        const thumbWidth = Math.max((track.clientWidth / track.scrollWidth) * scrollbarWidth, 40);
        const thumbOffset = (track.scrollLeft / maxScroll) * (scrollbarWidth - thumbWidth);

        thumb.style.width = `${thumbWidth}px`;
        thumb.style.transform = `translateX(${thumbOffset}px)`;
      };

      const requestUpdate = () => {
        if (frame) {
          return;
        }

        frame = window.requestAnimationFrame(updateScrollbar);
      };

      track.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      window.requestAnimationFrame(updateScrollbar);
    }

    #initDragScroll() {
      const track = this.querySelector('[data-variant-bundle-selector-track]');

      if (!track || !window.matchMedia('(pointer: fine)').matches) {
        return;
      }

      const dragThreshold = 8;
      let isPointerDown = false;
      let isDragging = false;
      let startX = 0;
      let scrollLeft = 0;
      let suppressNextClick = false;

      const endDrag = () => {
        isPointerDown = false;
        isDragging = false;
        track.classList.remove('is-dragging');
      };

      const onPointerMove = (event) => {
        if (!isPointerDown) {
          return;
        }

        const walk = event.pageX - startX;

        if (!isDragging && Math.abs(walk) < dragThreshold) {
          return;
        }

        isDragging = true;
        suppressNextClick = true;
        track.classList.add('is-dragging');
        track.scrollLeft = scrollLeft - walk;
      };

      const onPointerUp = () => {
        if (!isPointerDown) {
          return;
        }

        endDrag();
        document.removeEventListener('pointermove', onPointerMove);
        document.removeEventListener('pointerup', onPointerUp);
        document.removeEventListener('pointercancel', onPointerUp);
      };

      track.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) {
          return;
        }

        isPointerDown = true;
        isDragging = false;
        suppressNextClick = false;
        startX = event.pageX;
        scrollLeft = track.scrollLeft;

        document.addEventListener('pointermove', onPointerMove);
        document.addEventListener('pointerup', onPointerUp);
        document.addEventListener('pointercancel', onPointerUp);
      });

      track.addEventListener('dragstart', (event) => {
        event.preventDefault();
      });

      track.addEventListener(
        'click',
        (event) => {
          if (!suppressNextClick) {
            return;
          }

          suppressNextClick = false;
          event.preventDefault();
          event.stopPropagation();
        },
        true
      );
    }
  }

  if (!customElements.get('variant-bundle-selector')) {
    customElements.define('variant-bundle-selector', VariantBundleSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
